import {BookingService} from '../services';
import {bindLoading} from './index';
import {SystemKey} from '../constants';

export default {
    namespaced:true,
    state:{
    },
    mutations:{
    },
    actions:{
        async isCollidedAction({commit}, {
            schoolYear,
            semester,
            begin,
            end,
            date,
            roomId
        }){
            return await bindLoading(commit, async () => {
                return  await BookingService.isCollided({
                    schoolYear,
                    semester,
                    begin,
                    end,
                    date,
                    roomId
                });
            }, 'booking');
        },

        async submitAction({commit}, form){
            return await bindLoading(commit, async () => {
                return  await BookingService.submit({...form, systemKey : SystemKey});
            }, 'booking');
        },

        async adminSubmitAction({commit}, form){
            return await bindLoading(commit, async () => {
                return await BookingService.adminSubmit({...form, systemKey : SystemKey});
            }, 'booking');
        },

        async getVacancyClassroomsAction({commit}, params){
            return await bindLoading(commit, async () => {
                return await BookingService.getVacancyRooms({...params});
            }, 'booking')
        }
    }
}